import _ from 'underscore';
import Backbone from 'backbone';
import Localizer from 'localizer';
import NavigationUtil from 'utils/NavigationUtil';
import MenuItemChildView from 'views/navigation/MenuItemChildView';
import MainNavUtil from 'utils/MainNavUtil';
import LeftNavigationAnalytics from 'utils/LeftNavigationAnalytics';
import viewerUserPreferences from 'models/user/ViewerUserPreferences';
import templateHtml from 'templates/navigation/MenuItemView.html';

import ReactComponentView from 'views/main/react/ReactComponentView';
import { ChartsBar } from 'ui-icons';

import 'styles/connections.page.module.css';

var Events = {
    NAV_ITEM_SELECTED: 'NAV_ITEM_SELECTED',
    REFRESH_BUBBLE: 'REFRESH_BUBBLE'
};

var MenuItemView = Backbone.View.extend({
    tagName: 'li',
    className: 'main-nav-item',
    events: {
        'click .main-nav-link': 'onClick'
    },

    initialize: function(args) {
        this.template = _.template(templateHtml);
        this.active = args.active;
        this.className = args.className || 'main-nav-item';

        if (this.model.title === 'news_feed') {
            this.newsFeedStatus = args.newsFeedStatus;
        }
    },

    /**
     * Render the sidebar.
     */
    render: function() {
        var linkClass = 'main-nav-link';
        linkClass += this.model.disabled ? ' read-only' : '';
        linkClass += this.model.uiIcon ? ' react-link' : ''; // the ui-icons have a different size and need some padding removed

        var html = this.template({
            title: this.getLabel(),
            showNewsFeedBubble:
                this.model.title === 'news_feed' &&
                this.newsFeedStatus &&
                !!this.newsFeedStatus.get('lastUnreadPostExpirationTimeGMT'),
            link: this.model.url ? NavigationUtil.url(this.model.url) : null,
            icon: this.model.icon,
            uiIcon: !!this.model.uiIcon,
            linkClass: linkClass,
            hasChildren: this.hasChildren()
        });
        this.$el.html(html);
        if (this.hasChildren()) {
            this.renderChildElements();
        }
        this.checkHighlight();

        if (!!this.model.uiIcon) {
            this.renderUIIcon();
        }

        Backbone.history.on('route', this.checkHighlight.bind(this));
        return this;
    },

    checkHighlight: function() {
        if (this.matchesUrl()) {
            this.trigger(Events.NAV_ITEM_SELECTED);
            this.highlight();
        }
    },

    getLabel: function() {
        if (this.model.label) {
            return this.model.label;
        }
        return Localizer.localize(this.model.title);
    },

    hasChildren: function() {
        return !!this.model.menuItems;
    },

    renderChildElements: function() {
        _.each(
            this.model.menuItems,
            function(item) {
                var menuItem = new MenuItemChildView({
                    model: item
                });
                this.listenTo(menuItem, Events.NAV_ITEM_SELECTED, function() {
                    this.trigger(Events.NAV_ITEM_SELECTED);
                    this.highlight();
                });
                this.$('.main-nav-menu').append(menuItem.render().el);
                if (menuItem.matchesUrl()) {
                    this.highlight();
                }
            },
            this
        );
    },

    onClick: function(e) {
        if (this.model.title === 'news_feed') {
            let $newsfeedUnreadBubble = this.$('.newsfeedUnreadBubble');
            if ($newsfeedUnreadBubble) {
                $newsfeedUnreadBubble.hide();
            }
            viewerUserPreferences.setNewsFeedLastReadTimeCookies();
        }

        if (e) {
            if (!e.ctrlKey && !e.metaKey) {
                e.preventDefault();
            }
            e.stopPropagation();
        }

        if (this.hasChildren()) {
            this.$el.toggleClass('open-main-nav-menu');
            this.$('.main-nav-menu').slideToggle(200);
            MainNavUtil.saveToggledNavItem(this.$el);
        } else {
            NavigationUtil.anchorTagHandler(e);
            LeftNavigationAnalytics.push(this.model.title);
            this.trigger(Events.NAV_ITEM_SELECTED);
            this.highlight();
        }
    },

    matchesUrl: function() {
        if (!this.hasChildren()) {
            var pathname = window.location.pathname;
            var entryKeyword = this.model.urlKeyword;
            if (entryKeyword && pathname.indexOf(entryKeyword) !== -1) {
                return true;
            } else {
                return pathname.indexOf(this.model.url) !== -1;
            }
        }

        return false;
    },

    renderUIIcon: function() {
        this.reactIcon = new ReactComponentView();

        this.reactIcon.renderComponent(ChartsBar, this.$('.react-icon')[0]);
    },

    /**
     * Highlights the selected item.
     */
    highlight: function() {
        this.$('.main-nav-link')
            .first()
            .addClass('active');
    }
});

MenuItemView.Events = Events;

export default MenuItemView;
